@let data = model();

@switch (column().key) {
  @case (getColumnKey('buyer')) {
    {{ data.buyer.dignity }}
  }

  @case (getColumnKey('totalPrice')) {
    @if (isNil(data.refundSummary)) {
      <app-currency [amount]="data.totalPrice" />
    } @else {
      <app-refunded-price
        [currentPrice]="data.refundSummary.currentPrice"
        [refundedPrice]="data.refundSummary.refundedPrice"
        [originalPrice]="data.refundSummary.originalPrice" />
    }
  }

  @case (getColumnKey('number')) {
    <div class="flex items-center gap-2">
      <span>{{ data.number }}</span>

      @if (data.comment) {
        <span
          class="flex text-gray-500"
          tooltipPosition="bottom"
          [pTooltip]="data.comment">
          <app-icon [icon]="Icon.Chat" />
        </span>
      }
    </div>
  }

  @case (getColumnKey('hasError')) {
    @if (data.hasError) {
      <div
        class="flex items-center gap-2 text-red-500"
        tooltipPosition="bottom"
        [pTooltip]="data.errorMessage!">
        <app-icon [icon]="Icon.ExclamationCircleFill" />

        <span class="text-xs">Najedź kursorem, aby zobaczyć szczegóły</span>
      </div>
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('status')) {
    <app-order-status [status]="data.status" />
  }

  @case (getColumnKey('shippingMethods')) {
    @for (method of data.shippingMethods; track method.id) {
      <div class="inline-flex">
        <div>{{ method.name }}</div>

        @if (!$last) {
          <div class="me-1">,</div>
        }
      </div>
    }
  }

  @case (getColumnKey('paymentMethod')) {
    {{ data.paymentMethod.name }}
  }

  @case (getColumnKey('shippingCountries')) {
    @for (shippingCountry of data.shippingCountries; track shippingCountry.id) {
      <div class="inline-flex">
        <div>{{ shippingCountry.isoCode }}</div>

        @if (!$last) {
          <div class="me-1">,</div>
        }
      </div>
    } @empty {
      <app-no-data />
    }
  }

  @case (getColumnKey('products')) {
    @for (product of data.products; track product) {
      <div class="flex gap-1">
        <div>{{ product.name }}</div>
        <div>({{ product.quantity }})</div>
      </div>
    } @empty {
      <app-no-data />
    }
  }

  @case (getColumnKey('invoices')) {
    <div class="flex flex-col gap-1">
      @for (invoice of data.invoices; track invoice.id) {
        <div class="flex gap-1">
          @if (invoice.canBeDownloaded) {
            <p-button
              (onClick)="handleDownloadInvoiceClick(invoice.id)"
              variant="outlined"
              tooltipPosition="bottom"
              pTooltip="Pobierz fakturę">
              {{ invoice.number }}
            </p-button>
          } @else {
            {{ invoice.number }}
          }
        </div>
      } @empty {
        <app-no-data />
      }
    </div>
  }

  @case (getColumnKey('shipments')) {
    <div class="flex flex-col gap-1">
      @for (shipment of data.shipments; track shipment.id) {
        <div class="flex items-center gap-1">
          <div class="me-2">
            <app-shipment-status
              [withColors]="true"
              [status]="shipment.status" />
          </div>

          @if (shipment.isSent()) {
            @if (isNotNil(shipment.trackingUrl)) {
              <div>
                <app-external-link [link]="shipment.trackingUrl">
                  <p-button
                    [tabindex]="-1"
                    variant="outlined"
                    tooltipPosition="bottom"
                    pTooltip="Śledź przesyłkę">
                    <app-icon [icon]="Icon.GlobeAlt" />
                  </p-button>
                </app-external-link>
              </div>
            }

            <div>
              <p-button
                (onClick)="handleDownloadLabelClick(shipment.id)"
                variant="outlined"
                tooltipPosition="bottom"
                pTooltip="Pobierz etykietę">
                <app-icon [icon]="Icon.CloudDownloadFill" />
              </p-button>
            </div>
          }

          @if (shipment.isPending()) {
            @if (isNotNil(shipment.scheduledShippingDate)) {
              <div
                class="flex"
                pTooltip="Planowana data wysłki">
                <div>(</div>
                <app-date-month-with-year
                  [date]="shipment.scheduledShippingDate" />
                <div>)</div>
              </div>
            }
          }
        </div>
      } @empty {
        <app-no-data />
      }
    </div>
  }

  @case (getColumnKey('variants')) {
    @if (data.variants) {
      @for (variant of data.variants; let isLast = $last; track variant) {
        <span>{{ variant }}</span>

        @if (!isLast) {
          <span>, </span>
        }
      }
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('skinType')) {
    @if (data.skinType) {
      {{ data.skinType }}
    } @else {
      <app-no-data />
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
